<template>
    <div class="container-center">

        <el-form class="notice-form" label-width="140px" ref="form" :model="form" :rules="rules">
            <el-row>
                <el-col :span="5">
                    <el-form-item label="公告名称：" prop="name">
                        <el-input size="medium" v-model="form.title" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="事项类型：" prop="name">
                        <el-select size="mini" v-model="form.eventType" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="冻结" value="1"></el-option>
                            <el-option label="禁用" value="2"></el-option>
                            <el-option label="技术标不合格" value="3"></el-option>
                            <el-option label="黄牌警告" value="4"></el-option>
                            <el-option label="解冻" value="5"></el-option>
                            <el-option label="停用" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="发布日期：">
                        <el-col :span="11">
                            <el-date-picker type="date" v-model="form.startDate" placeholder="选择日期" size="medium" style="width: 100%;" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2"><center>-</center></el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" v-model="form.endDate" placeholder="选择日期" size="medium" style="width: 100%;" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                        </el-col>
                    </el-form-item>
                </el-col>
                <el-col :span="2" :offset="1">
                    <el-button type="warning" class="btn-theme" size="medium" @click="getNoticeList" icon="el-icon-search">搜索</el-button>
                </el-col>
            </el-row>
        </el-form>


        <div class="notice-list-box">
            <div class="no-data-tip" v-if="noticeList.length == 0"></div>
            <div v-else class="notice-list" v-for="li in noticeList">
                <p class="title" ><router-link :to="{name:'NoticeInfo',params:{ id:li.id }}" >{{ li.title }}</router-link></p>
                <p class="date">{{ li.issueDate && li.issueDate.substring(0,10) }}</p>
            </div>
        </div><!-- .notice-list-box -->


        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="10"
                :current-page="pager.pageNum"
                :total="pager.total"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                background
                >
            </el-pagination>
        </div>


    </div><!-- container-center -->
</template>

<script>
import banner from '@/assets/imgs/banner_invite.png'
import filter from '@/filter'

export default {
    name: 'notice-list',
    data () {
        return {
            rules: {

            },
            noticeList: [],

            form: {
                title: '',
                eventType: '',
                startDate: '',
                endDate: ''
            },

            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            }

        }
    },
    methods: {
        getNoticeList () {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    // this.submitForm()
                    this.$http.post('rest/api/group/content/getContentList',
                        Object.assign({
                                pageNum: this.pager.pageNum,
                                pageSize: this.pager.pageSize
                            }, {
                                title: this.form.title,
                                eventType: this.form.eventType,
                                startDate: this.form.startDate ? filter.date(new Date(this.form.startDate)) +' 00:00:00' : '',
                                endDate:  this.form.endDate ? filter.date(new Date(this.form.endDate)) +' 23:59:59' : ''
                            }

                        )
                    ).then((res)=>{
                        if(res.data.result) {
                            this.noticeList = res.data.value.list;
                            this.pager.total = res.data.value.count;
                            this.pager.pageNum = res.data.value.pageNo;
                        }
                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        handleCurrentChange (page) {
            this.pager.pageNum = page;
            this.getNoticeList();
        }

    },
    created(){
        this.$root.navs = [{name:'公告',path:'/notice'}];
        this.$root.headImage.src = banner;
    },
    mounted () {
        this.getNoticeList();
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';

.clearfix:after {display: table;content: " ";clear: both;}

.notice-form {background: #F5F6F5;padding: 25px 10px 10px 10px;margin: 24px 0;}

.notice-list {width: 100%;height: 48px;border-bottom: 1px solid #E4E5E4;}
.notice-list > p {font-size: 16px;margin:0;line-height: 48px;}
.notice-list > p.title {float: left;width: 1000px;font-weight: bold;}
.notice-list > p.title a {color: #000;text-decoration: none;}
.notice-list > p.title a:hover {color: var(--cMain);}
.notice-list .date {float: right;}


</style>



// WEBPACK FOOTER //
// src/pages/dsp/notice/NoticeList.vue